/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import LabTestOrdersLabTestOrder from './LabTestOrdersLabTestOrder';

/**
 * The LabTestOrdersBody model module.
 * @module model/LabTestOrdersBody
 * @version v0.3
 */
export default class LabTestOrdersBody {
  /**
   * Constructs a new <code>LabTestOrdersBody</code>.
   * @alias module:model/LabTestOrdersBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>LabTestOrdersBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LabTestOrdersBody} obj Optional instance to populate.
   * @return {module:model/LabTestOrdersBody} The populated <code>LabTestOrdersBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new LabTestOrdersBody();
      if (data.hasOwnProperty('lab_test_order'))
        obj.labTestOrder = LabTestOrdersLabTestOrder.constructFromObject(data['lab_test_order']);
    }
    return obj;
  }
}

/**
 * @member {module:model/LabTestOrdersLabTestOrder} labTestOrder
 */
LabTestOrdersBody.prototype.labTestOrder = undefined;

